import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import React, { ReactElement } from 'react';
import Head from 'next/head';

import { Header } from 'components/layouts';
import { withAuthCandidate } from 'lib/hocs/withAuthCandidate';
import { CandidateProfileProvider } from 'lib/contexts/candidate-profile-context';
import { BuildProfile } from './BuildProfile/BuildProfile.component';

const CandidateBuildProfilePage = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Profile | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <CandidateProfileProvider>
        <Header>
          <BuildProfile />
        </Header>
      </CandidateProfileProvider>
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'candidate.profile.modal',
        'common',
        'candidate.profile',
      ])),
    },
  };
}

const CandidateBuildProfilePageWrapper = withAuthCandidate(
  CandidateBuildProfilePage
);

export default CandidateBuildProfilePageWrapper;
